import React from 'react';
//import emailjs from '@emailjs/browser';
//import bg1 from './../assets/images/background/bg1.jpg';
import { webinsertinnewsletteremail} from './../components/APISCollection';
function NewsLetter({subscribeChange}){     
	const sendEmail = (e) => {
        var strEmailID = document.getElementById("txtSubscribeEmailID").value;

        let Eregex = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);
        
        if (Eregex.test(strEmailID) === false) {
            alert("Please enter a valid emailid!")
            return false;
        }

        if(strEmailID === "" || strEmailID === null || strEmailID === undefined){
            alert("Please enter a valid email for subscribe our news letter.");
            return false;
        }

        webinsertinnewsletteremail(strEmailID).then((result)=>{
             if(result.data[0].Result === "subscribed"){
                document.getElementById("txtSubscribeEmailID").value = "";
                alert("You have successfully subscribed our news & letters.");
             }else if(result.data[0].Result === "Failed"){
                document.getElementById("txtSubscribeEmailID").value = "";
                alert("Failed subscribed our news & letters, Please try again.");
             }else{
                document.getElementById("txtSubscribeEmailID").value = "";
                alert(result.data[0].Result);
             }
        }); 
	};	
    return(
        <>
            <section className={`py-3 newsletter-wrapper`} >
                <div className="container">
                    <div className="subscride-inner">
                        <div className="row style-1 justify-content-xl-between justify-content-lg-center align-items-center text-xl-start text-center">
                            <div className="col-xl-7 col-lg-12 ">
                                <div className="section-head mb-0">
                                    <h2 className="title text-white my-lg-3 mt-0">Subscribe our newsletter for newest books updates</h2>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6 " >
                                <div className="dzSubscribe style-1">
                                    <div className="dzSubscribeMsg"></div>
                                    <div className="form-group">
                                        <div className="input-group mb-0">
                                            <input name="dzEmail" required="required" id="txtSubscribeEmailID" type="email" className="form-control bg-transparent " placeholder="Your Email Address" />
                                            <div className="input-group-addon">
                                                <button name="submit" value="Submit" type="button" className="btn btn-primary btnhover" onClick={sendEmail} >
                                                    <span>SUBSCRIBE</span><i className="fa-solid fa-paper-plane"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default NewsLetter;